const normalizeUserStatusId = (statusId) => {
	if (typeof statusId !== "number" && typeof statusId !== "string") return null;
	if (typeof statusId === "string" && statusId.trim() === "") return null;
	const normalizedStatusId = Number(statusId);
	return [-1, 0, 1].includes(normalizedStatusId) ? normalizedStatusId : null;
};

export const getUserStatusLabel = (statusId) => {
	switch (normalizeUserStatusId(statusId)) {
		case 1:
			return "Active";
		case 0:
			return "Disabled";
		case -1:
			return "Inactive (180 days)";
		default:
			return "Unknown";
	}
};

export const getUserStatusActionLabel = (statusId) => {
	switch (normalizeUserStatusId(statusId)) {
		case 1:
			return "Disable";
		case 0:
		case -1:
			return "Enable";
		default:
			return null;
	}
};

export const getNextUserStatus = (statusId) => {
	switch (normalizeUserStatusId(statusId)) {
		case 1:
			return 0;
		case 0:
		case -1:
			return 1;
		default:
			return null;
	}
};

export const getUserStatusChangeVerb = (statusId) => {
	switch (normalizeUserStatusId(statusId)) {
		case 0:
			return "disabled";
		case 1:
			return "enabled";
		default:
			return null;
	}
};
